import ActionPanelButtonWrapper from './ActionPanelButtonWrapper';

export default ActionPanelButtonWrapper;
